import { render, staticRenderFns } from "./payDelivary.vue?vue&type=template&id=0162b634&"
import script from "./payDelivary.vue?vue&type=script&lang=js&"
export * from "./payDelivary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports